import { FC, useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { get, isEmpty, isNil } from 'lodash';
import { Container } from 'containers/ExpertExpertise/style';
import Victim from 'containers/ExpertExpertise/Victim/index';
import Vehicle from 'containers/ExpertExpertise/Vehicle/index';
import ConcernedExpertise from 'containers/ExpertExpertise/ConcernedExpertise/index';
import { DATE_FORMAT } from 'constants/global';
import {
  makeSelectVictimExpertise,
  makeSelectMissionPostPonse,
  makeSelectMissionPostPonseExpertise,
} from 'containers/ExpertExpertise/selectors';
import { requestGetExpertiseVictim } from 'containers/ExpertExpertise/actions';
import { filterExpertiseVictim } from 'containers/ExpertExpertise/utils';
import { ClaimRecapType } from 'typings/claimTypes';
import { requestFeeNotesByClaimNumb } from 'containers/LawyerFeeNote/actions';
import { renderSearchQuery } from 'containers/ExpertAssignedMissionShow/utils';

export interface ExpertExpertiseProps {
  intl: IntlShape;
  victim: any;
  mission: any;
  requestCreateVictimExpertise: Function;
  sagis_code: any;
  claimRecap: ClaimRecapType;
  vehicle: any;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  requestGetDocByDocumentumId: Function;
  requestClaimRecap: Function;
  requestSearchClaims: Function;
}

const ExpertExpertise: FC<ExpertExpertiseProps> = props => {
  const dispatch = useDispatch();
  const { victim, mission, vehicle } = props;
  const missionId = get(mission, 'id');
  const missionVictimId = get(mission, 'missionVictim')?.find(
    (element: { missionId: number; victimId: number }) =>
      element.victimId === victim?.id,
  )?.id;
  useEffect(() => {
    dispatch(
      requestFeeNotesByClaimNumb(
        get(props.claimRecap, 'claim.claimNumber', null),
      ),
    );
  }, [props.claimRecap]);
  useEffect(() => {
    if (!isNil(get(mission, 'claimId', null))) {
      props.requestClaimRecap(get(mission, 'claimId', null));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [missionId]);
  useEffect(() => {
    if (!isEmpty(props.claimRecap)) {
      const searchQuery = renderSearchQuery(props.claimRecap);
      props.requestSearchClaims(searchQuery);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.claimRecap]);

  const missionVehicleId = get(mission, 'vehicles')?.find(
    (element: { missionId: number; id: number }) => element.id === vehicle?.id,
  )?.MissionVehicle?.id;
  useEffect(() => {
    if (missionId && (missionVictimId || missionVehicleId)) {
      dispatch(
        requestGetExpertiseVictim({
          missionId,
          missionVictimId: missionVictimId ? missionVictimId : null,
          isIntervenant: true,
          missionVehicleId,
        }),
      );
    }
  }, [!missionId, !missionVictimId, !missionVehicleId]);
  const expertiseVictim: any = useSelector(makeSelectVictimExpertise());
  const missionPostPone: any = useSelector(makeSelectMissionPostPonse());
  const missionPostPoneExpertise: any = useSelector(
    makeSelectMissionPostPonseExpertise(),
  );
  return (
    <Container>
      {mission && (
        <>
          {!isEmpty(victim) && (
            <Victim
              victim={victim}
              courtFileNumber={mission?.courtFileNumber}
              expertiseDate={moment(mission?.missionDate).format(DATE_FORMAT)}
              missionReference={mission?.reference}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            />
          )}
          {!isEmpty(vehicle) && (
            <Vehicle
              vehicle={vehicle}
              courtFileNumber={mission?.courtFileNumber}
              expertiseDate={moment(mission?.missionDate).format(DATE_FORMAT)}
              missionReference={mission?.reference}
            />
          )}
          <ConcernedExpertise
            victim={victim}
            mission={mission}
            vehicle={vehicle}
            expertiseVictim={filterExpertiseVictim(
              expertiseVictim,
              props.sagis_code,
            )}
            requestCreateVictimExpertise={props.requestCreateVictimExpertise}
            missionPostPone={missionPostPone}
            missionPostPoneExpertise={missionPostPoneExpertise}
            sagis_code={props.sagis_code}
            sagisVictimInfo={props.sagisVictimInfo}
            sagisOpposingParties={props.sagisOpposingParties}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            claimNumber={get(props.claimRecap, 'claim.claimNumber', null)}
            lossDate={get(props.claimRecap, 'claim.lossDate', null)}
          />
        </>
      )}
    </Container>
  );
};

export default injectIntl(ExpertExpertise);
